export enum SortOptions {
  ASC = 'ASC',
  DESC = 'DESC',
}
export interface GQL_SortingInput {
  field: string;
  order?: SortOptions;
}
